var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Instance',{attrs:{"instance":"userActivityLog","instance-name":"User Activity Log","get":d => _vm.userActivityLog.get(d),"columns":_vm.columns,"initFilter":_vm.filter,"showActions":false,"showDateFilter":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }